import { graphql } from "~/gql";

export const INTEGRATION_RECORD_COUNT_QUERY = graphql(/* GraphQL */ `
  query IntegrationRecordCount {
    integrationRecordCountQuery {
      organisationalUnits
      officeLocations
      feeEarnerLevels
      feeEarners
      users
      clients
      rates
      externalMatters
      timeEntries
      matterPermissions
      matterInvoices
      currencies
    }
  }
`);
